/** dataTransfer key used for cross-list drag-and-drop payloads. */
export const REORDERABLE_TRANSFER_KEY = 'application/x-reorderable-group'

/**
 * Remove an item at the given index. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} index
 * @returns {Array}
 */
export function removeAt(items, index) {
  if (index < 0 || index >= items.length) return items

  const updated = [...items]
  updated.splice(index, 1)
  return updated
}

/**
 * Move an item from one index to another. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {Array}
 */
export function moveItem(items, fromIndex, toIndex) {
  if (
    fromIndex == null ||
    toIndex == null ||
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= items.length ||
    toIndex >= items.length
  ) {
    return items
  }

  const updated = [...items]
  const [moved] = updated.splice(fromIndex, 1)
  updated.splice(toIndex, 0, moved)
  return updated
}

/**
 * Move an item one position up. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} index
 * @returns {Array}
 */
export function moveUp(items, index) {
  if (index <= 0 || index >= items.length) return items

  return moveItem(items, index, index - 1)
}

/**
 * Move an item one position down. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} index
 * @returns {Array}
 */
export function moveDown(items, index) {
  if (index < 0 || index >= items.length - 1) return items

  return moveItem(items, index, index + 1)
}

/**
 * Insert an external item at the given index. Returns a new array.
 * @param {Array} items
 * @param {*} item
 * @param {number} index
 * @returns {Array}
 */
export function insertAt(items, item, index) {
  const clampedIndex = Math.max(0, Math.min(index, items.length))
  const updated = [...items]
  updated.splice(clampedIndex, 0, item)
  return updated
}
